import { Component } from '@angular/core';
import { AdminListSuppliersComponent } from '../../../../components/admin-dashboard-component/admin-suppliers-component/admin-list-suppliers-component/admin-list-suppliers-component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-admin-list-suppliers',
  imports: [AdminListSuppliersComponent, RouterLink],
  templateUrl: './admin-list-suppliers.html',
  styleUrl: './admin-list-suppliers.scss',
})
export class AdminListSuppliers {}
